import {Directive, ElementRef, HostListener, Input, OnInit, Renderer2, TemplateRef, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[appCollapse]',
    standalone: false
})
export class CollapseDirective {
    isOpen: boolean = false;

    @Input('appCollapse') collapseEl!: ElementRef;

    constructor(private elRef: ElementRef, private renderer: Renderer2) {
    }

    @HostListener('click')
    toggleOpen() {
        this.isOpen = !this.isOpen;

        // const menuEl = this.elRef.nativeElement.getElementsByClassName('collapse')[0];

        if (this.isOpen) {
            this.renderer.addClass(this.collapseEl, 'show');
        } else {
            this.renderer.removeClass(this.collapseEl, 'show');
        }
    }
}
